import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import Flex from 'ui/Flex/Flex';
import { FreeHypothesis } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/PayConstants/components/FreeHypothesis/helpers/types';
import {
    formatOperationType,
    formatHypothesisText,
} from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/PayConstants/components/FreeHypothesis/helpers/dataHelpers';
import parse from 'html-react-parser';
import { SimulationDateString } from 'routes/HumanResourcesModule/Simulation/helpers/types';

type Props = {
    hypothesis: FreeHypothesis;
};
// Used to display free hypothesis in the duplication/obsolete section
const FreeHypothesisDisplay = ({ hypothesis }: Props): React.ReactElement => {
    const { t } = useTranslation();
    const { value, filters, operation, valueType } = hypothesis;
    const {
        category,
        filiere,
        cadreEmploi,
        jobLabel,
        date,
        greaterThan,
        lowerThan,
    } = filters;

    return (
        <Flex
            direction="column"
            sx={{
                align: 'center',
                justifyContent: 'space-between',
                marginBottom: '10px',
                alignItems: 'flex-start',
            }}
        >
            <Typography
                variant="body1SemiBold"
                sx={(theme) => ({
                    color: theme.palette.darkGrey,
                    mb: '0.2rem',
                })}
            >
                {t('humanResources.simulation.freeHypothesis.ifse.resumeTitle')}
            </Typography>

            <Typography
                sx={(theme) => ({
                    color: theme.palette.darkGrey,
                    maxWidth: '85%',
                })}
            >
                {parse(
                    t(
                        `humanResources.simulation.freeHypothesis.duplicationText`,
                        {
                            operation: formatOperationType(
                                operation,
                                value,
                                valueType,
                            ),
                            data: formatHypothesisText(
                                category,
                                filiere,
                                cadreEmploi,
                                jobLabel,
                                date as SimulationDateString,
                                greaterThan,
                                lowerThan,
                            ),
                        },
                    ),
                )}
            </Typography>
        </Flex>
    );
};

export default FreeHypothesisDisplay;
